/**
 * EventDropAttribution ✦ iter218
 *
 * A restrained footer attribution shown on un-registered guest
 * surfaces (galleries, public share pages, host event pages).
 *
 * Purpose: turn every gallery visitor into a potential future
 * customer for the commercial vertical without breaking the
 * editorial restraint of the memory platform.
 *
 * Constitutional rules:
 *   • This component is INTENTIONALLY excluded from the atmosphere-
 *     registered surfaces (GuestAccessPage / RememberUsPage /
 *     FinalNightPage / EventCompanions / SchoolsPage / Booth OS).
 *     Those are participation surfaces under full atmosphere
 *     contract — commercial language never appears there.
 *   • Copy stays quiet (single hairline above, italic serif,
 *     reduced opacity). No bright CTAs, no "BOOK NOW".
 *   • The link target is /photobooth-hire — never /create or any
 *     editorial flow, so the attribution is unambiguous about what
 *     it offers.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const SERIF = 'Georgia, "Cormorant Garamond", "Times New Roman", serif';

const EventDropAttribution = ({
  align = 'center',
  variant = 'default', // 'default' or 'inline' (smaller, single line)
}) => {
  if (variant === 'inline') {
    return (
      <Link
        to="/photobooth-hire"
        data-testid="eventdrop-attribution-inline"
        style={{
          display: 'inline-block',
          fontFamily: SERIF, fontStyle: 'italic',
          fontSize: 12, color: 'rgba(212,170,82,0.62)',
          letterSpacing: '0.06em',
          textDecoration: 'none',
        }}
      >
        Captured using EventDrop ✦
      </Link>
    );
  }

  return (
    <div
      data-testid="eventdrop-attribution"
      style={{
        padding: 'clamp(28px, 5vw, 48px) 24px clamp(36px, 5vw, 56px)',
        textAlign: align,
        borderTop: '1px solid rgba(212,170,82,0.10)',
        marginTop: 40,
      }}
    >
      <Link
        to="/photobooth-hire"
        data-testid="eventdrop-attribution-link"
        style={{
          display: 'inline-block',
          fontFamily: SERIF, fontStyle: 'italic',
          fontSize: 14.5, color: 'rgba(255,235,200,0.78)',
          letterSpacing: '0.02em',
          textDecoration: 'none',
          marginBottom: 6,
        }}
      >
        Captured using EventDrop <span style={{ color: '#D4AF5E' }}>✦</span>
      </Link>
      <div style={{
        fontFamily: SERIF, fontStyle: 'italic',
        fontSize: 11.5, color: 'rgba(255,235,200,0.46)',
        letterSpacing: '0.22em', textTransform: 'uppercase',
        marginTop: 2,
      }}>
        Photobooth Hire · Audio Guestbooks · Event Experiences
      </div>
    </div>
  );
};

export default EventDropAttribution;
